import { StopStatuses } from "@jumbo/constants/AppConstants";

export function isTheCurrentStatusChangedToDeliveredInFinalStop(store, res){
    let loadStops = store.getState().tracking?.selectedLoad?.stops;
    let lastStopId = loadStops?.length ? loadStops[loadStops.length-1]?.id : null

    let loadStopsPrevious = store.getState().tracking?.selectedLoadLocation?.load_details?.stops
    let loadStopsCurrent = res?.data?.load_details?.stops

    if(loadStopsCurrent?.length && loadStopsPrevious?.length && lastStopId){
      let previousLastStopStatus = loadStopsPrevious.find(s=>s.id===lastStopId)?.user_status
      let currentLastStopStatus = loadStopsCurrent.find(s=>s.id===lastStopId)?.user_status

      if(previousLastStopStatus != StopStatuses.DELIVERED &&
        currentLastStopStatus === StopStatuses.DELIVERED){
          return true;
        }
    }  
    return false;
}